/**
 * Routes fragments
 */
export const BaseRoutePath = '';

// Generic
export const NotFoundRoutePath = 'not-found';
export const ForbiddenRoutePath = 'forbidden';

// Authentication
export const AuthenticationRoutePath = 'authentication';
export const LoginRoutePath = 'login';
export const RegisterRoutePath = 'register';
export const LogoutRoutePath = 'logout';
export const NoCompteRoutePath = 'no-compte';

// Anonymous
export const AnonymousRoutePath = 'anonymous';

// Authenticated
export const AuthenticatedRoutePath = 'authenticated';

// Home
export const HomeRoutePath = 'home';

// Graphic Elements
export const GraphicRoutePath = 'graphic';

// Affaires
export const AffairesRoutePath = 'affaires';
export const AffaireCreateRoutePath = 'create';
export const AffaireEditRoutePath = 'edit/:id';
export const MesAffairesRoutePath = 'owned';
export const AffairesArchivesRoutePath = 'archives';
export const AffairesSearchRoutePath = 'search';
export const AffaireDetailsRoutePath = 'search/:id';
export const OperationsRoutePath = 'operations';
export const OperationsSearchRoutePath = 'search';

// Labft
export const BenefEffectifRoutePath = "registre-benef-effectif";
// Settings
export const SettingsRoutePath = 'settings';

// Contact
export const ContactRoutePath = 'contact';

// Privacy Policy
export const PrivacyPolicyRoutePath = 'privacyPolicy';

// Version
export const VersionRoutePath = 'version';

// Documents
export const DocumentRoutePath = 'document';
export const DocumentAffaireBordereauRoutePath = 'affaire-bordereau';

// Alertes
export const AlertesRoutePath = 'alertes';

/**
 * Routes full paths
 */
export function getBasePath(): string {
	return BaseRoutePath;
}

// Generic pages
export function getNotFoundFullPath(): string {
	return `${getBasePath()}/${NotFoundRoutePath}`;
}

export function getForbiddenFullPath(): string {
	return `${getBasePath()}/${ForbiddenRoutePath}`;
}

// Authentication pages
export function getAuthenticationFullPath(): string {
	return `${getBasePath()}/${AuthenticationRoutePath}`;
}

export function getLoginFullPath(): string {
	return `${getAuthenticationFullPath()}/${LoginRoutePath}`;
}

export function getRegisterFullPath(): string {
	return `${getAuthenticationFullPath()}/${RegisterRoutePath}`;
}

export function getLogoutFullPath(): string {
	return `${getAuthenticationFullPath()}/${LogoutRoutePath}`;
}

// Authenticated pages
export function getAuthenticatedFullPath(): string {
	return `${getBasePath()}/${AuthenticatedRoutePath}`;
}

// Home
export function getHomeFullPath(): string {
	return `${getAuthenticatedFullPath()}/${HomeRoutePath}`;
}

// Affaires
export function getAffairesFullPath(): string {
	return `${getAuthenticatedFullPath()}/${AffairesRoutePath}`;
}

export function getAffaireCreateFullPath(): string {
	return `${getAffairesFullPath()}/${AffaireCreateRoutePath}`;
}

export function getAffaireEditFullPath(id: string): string {
	return `${getAffairesFullPath()}/${AffaireEditRoutePath.replace(':id', '' + id)}`;
}

export function getAffairesMesAffairesFullPath(): string {
	return `${getAffairesFullPath()}/${AffairesSearchRoutePath}`;
}

export function getAffairesArchivesFullPath(): string {
	return `${getAffairesFullPath()}/${AffairesArchivesRoutePath}`;
}

export function getAffaireDetailsFullPath(id: string): string {
	return `${getAffairesFullPath()}/${AffaireDetailsRoutePath.replace(':id', '' + id)}`;
}

// Financial Operations
export function getOperationsFullPath(): string {
	return `${getAuthenticatedFullPath()}/${OperationsRoutePath}`;
}

export function getSearchOperationsFullPath(): string {
	return `${getOperationsFullPath()}/${OperationsSearchRoutePath}`;
}

// registre Beneficiaire Effectif
export function getRegistreBenefEffectifFullPath(): string {
	return `${getAuthenticatedFullPath()}/${BenefEffectifRoutePath}`;
}

// Settings
export function getSettingsFullPath(): string {
	return `${getAuthenticatedFullPath()}/${SettingsRoutePath}`;
}

// Contact
export function getContactFullPath(): string {
	return `${getAuthenticatedFullPath()}/${ContactRoutePath}`;
}

// Policy Privacy
export function getPrivacyPolicyFullPath(): string {
	return `${getAuthenticatedFullPath()}/${PrivacyPolicyRoutePath}`;
}

// version
export function getVersionFullPath(): string {
	return `${getAuthenticatedFullPath()}/${VersionRoutePath}`;
}

// Document pages
export function getDocumentFullPath(): string {
	return `${getBasePath()}/${DocumentRoutePath}`;
}

export function getDocumentAffaireBordereauFullPath(): string {
	return `${getDocumentFullPath()}/${DocumentAffaireBordereauRoutePath}`;
}

// Alertes
export function getAlertesFullPath(): string {
	return `${getAuthenticatedFullPath()}/${AlertesRoutePath}`;
}
